import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { API_BASE } from "../api/apiConfig";

const Header = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const [mobileOpen, setMobileOpen] = useState(false);

  const isActive = (path) =>
    currentPath === path ? "text-primary font-semibold" : "text-white";

  return (
     <>

     <div className="hidden sm:block">
<header className="sticky top-0 z-50 w-full border-b border-white/10 backdrop-blur-md transition-all duration-300 bg-[#0F172A]/90 fullscreen-header">
      <div className="container mx-auto flex h-16 md:h-20 items-center justify-between px-4 md:px-6">
        <Link to="/" className="flex items-center">
          
            <div class="font-bold text-transparent bg-clip-text bg-gradient-to-r from-primary to-primary/80">
              <img alt="Logo" className="w-60"
                 src="/assets/images/logo1.png"
              />
              {/*<span class="text-xl md:text-2xl tracking-tight">Connecting</span
              ><span class="text-xl md:text-2xl tracking-tight ml-2 text-white">Traveller</span>*/}
          </div>

          </Link>
          <nav className="hidden md:flex items-center gap-6">
            <Link
              to="/community"
              className={`text-sm font-medium transition-colors hover:text-primary ${isActive("/community")}`}
            >
              Community
            </Link>

            <Link
              to="/ExperienceTrips"
              className={`text-sm font-medium transition-colors hover:text-primary ${isActive("/ExperienceTrips")}`}
            >
              Experience Trips
            </Link>

            <Link
              to="/grouptrips"
              className={`text-sm font-medium transition-colors hover:text-primary ${isActive("/GroupTrips")}`}
            >
              Group Trips
            </Link>

            <Link
              to="/customizedtrips"
              className={`text-sm font-medium transition-colors hover:text-primary ${isActive("/CustomizedTrips")}`}
            >
              Customized Trips
            </Link>
          </nav>

          <div className="hidden md:flex items-center gap-3">
              <Link to="/community">
                <button class="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-9 rounded-md px-3 border-white/20 bg-white/5 text-white hover:bg-white/10">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-users mr-2 h-4 w-4"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M22 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                Join Community
                </button>
              </Link>
              <Link to="/login">
                <button class="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-9 rounded-md px-3 bg-primary text-white hover:bg-primary/90">
                Sign In</button>
              </Link>
          </div>
          <div className="md:hidden">
            <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:text-accent-foreground h-9 rounded-md px-3 text-white hover:bg-white/10">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-menu h-5 w-5"
              >
                <line x1={4} x2={20} y1={12} y2={12} />
                <line x1={4} x2={20} y1={6} y2={6} />
                <line x1={4} x2={20} y1={18} y2={18} />
              </svg>
            </button>
          </div>
        </div>
      </header>
     </div>
      


      <div className='block sm:hidden'>
        <div className='mobile-app-container'>
          <header className="sticky top-0 z-40 bg-white/95 backdrop-blur-md border-b border-slate-100 shadow-sm fullscreen-header">
            <div className="px-4 py-2.5">
              <div className="flex justify-between items-center">
                <a href="/" className="flex items-center">
                  <img alt="Logo" className="w-60 mobiletest"
                     src="/assets/images/logo2.png"
                  />
                  {/*<div className="font-bold text-transparent bg-clip-text bg-gradient-to-r from-primary via-purple-500 to-pink-500 mr-2">
                    <span className="text-lg tracking-tight">CT</span>
                  </div>
                  <h2 className="text-base font-semibold text-slate-800">
                    Connecting Traveller
                  </h2>*/}
                </a>
                <div className="flex items-center gap-2.5">
                  <button className="flex items-center justify-center w-8 h-8 rounded-full bg-gradient-to-r from-primary/10 to-purple-500/10 hover:from-primary/20 hover:to-purple-500/20 transition-all">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-search h-4 w-4 text-slate-700"
                    >
                      <circle cx={11} cy={11} r={8} />
                      <path d="m21 21-4.3-4.3" />
                    </svg>
                  </button>
                  {/*<a href="/notifications">
                    <button className="relative flex items-center justify-center w-8 h-8 rounded-full bg-gradient-to-r from-primary/10 to-purple-500/10 hover:from-primary/20 hover:to-purple-500/20 transition-all">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-bell h-4 w-4 text-slate-700"
                      >
                        <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
                        <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
                      </svg>
                      <span className="absolute top-1 right-1 w-2 h-2 bg-gradient-to-r from-pink-500 to-red-500 rounded-full animate-pulse" />
                    </button>
                  </a>
                  <a href="/profile">
                    <div className="h-8 w-8 rounded-full overflow-hidden border-2 border-white/30 shadow-sm">
                      <img
                        alt="Profile"
                        loading="lazy"
                        width={32}
                        height={32}
                        decoding="async"
                        data-nimg={1}
                        className="object-cover"
                        style={{ color: "transparent" }}
                        src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/member-1-bOpGjZCsPuoiXPcWozfOLLcloeHRto.jpg"
                      />
                    </div>
                  </a>*/}
                </div>
              </div>
            </div>
          </header>

        </div>
      </div>

    </>
  );
};

export default Header;
